import { useTranslate } from "@similarweb/i18n-provider";

import IntegrationButtonWrapperWithFeatureRequest from "app/pages/sales-intelligence/modules/manage-integrations/components/integration-button/IntegrationButtonWrapperWithFeatureRequest";
import { StyledManagementCardButton } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/styles";
import { API_ITEMS_CONFIGS } from "app/pages/sales-intelligence/modules/manage-integrations/constants/api-items";
import { MANAGE_INTEGRATIONS_CARD_CONFIGURE } from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";
import manageIntegrationsTrackingService from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import { isSignalsRestApiAccountEnabled } from "app/pages/sales-intelligence/modules/manage-integrations/utils/signalsIntegrationActions";
import { StyledGatewayPrimaryButton } from "app/pages/sales-intelligence/pages/management/containers/GatewayPageContainer/styles";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

type SignalsRestApiGatewayButtonContainerProps = {
    variant?: "card" | "gateway";
};

const SignalsRestApiGatewayButtonContainer = ({
    variant = "card",
}: SignalsRestApiGatewayButtonContainerProps): React.ReactElement => {
    const { translate } = useTranslate();

    const isAccountEnabled = isSignalsRestApiAccountEnabled();

    const handleConfigureClick = () => {
        manageIntegrationsTrackingService.trackGatewayConnect("signalsRestApi");
        void siNavigator.goToManagementSignalsRestApiPage();
    };

    const handleUpgradeClick = () => {
        manageIntegrationsTrackingService.trackApiUpgradeClick("signalsRestApi");
    };

    const configureButton =
        variant === "gateway" ? (
            <StyledGatewayPrimaryButton
                buttonHtmlType="button"
                type="primary"
                iconName="link-out"
                placement="right"
                onClick={handleConfigureClick}
                data-automation="signals-rest-api.gateway-configure-button"
            >
                {translate(MANAGE_INTEGRATIONS_CARD_CONFIGURE)}
            </StyledGatewayPrimaryButton>
        ) : (
            <StyledManagementCardButton
                buttonHtmlType="button"
                type="primary"
                onClick={handleConfigureClick}
                data-automation="signals-rest-api.gateway-configure-button"
            >
                {translate(MANAGE_INTEGRATIONS_CARD_CONFIGURE)}
            </StyledManagementCardButton>
        );

    return (
        <IntegrationButtonWrapperWithFeatureRequest
            hookId={API_ITEMS_CONFIGS.signalsRestApi.hookId}
            dataAutomationNameSpace="signals-rest-api"
            upgradeButtonText={translate("si.common.contact_us")}
            isEnabled={isAccountEnabled}
            onUpgradeClick={handleUpgradeClick}
        >
            {configureButton}
        </IntegrationButtonWrapperWithFeatureRequest>
    );
};

export default SignalsRestApiGatewayButtonContainer;
